import { IRootState } from '../../../../store'
import { ICriticalCareState } from '../store/criticalCare.types'

export const getCriticalCareSelector = (state: IRootState): ICriticalCareState => state.criticalCare
